'use strict';

// Polyfills
require('./utils/assign-polyfill.js');
//
const navBreadcrumb = require('./modules/breadcrumb.js').init;
const navToc = require('./modules/nav-toc.js');
const forms = require('./modules/form.js');
const FormatHumanDate = require('./modules/format-date.js');
const contenttables = require('./modules/contenttable.js');
const accordions = require('./modules/accordion.js');
const share = require('./modules/share.js');
const isSmallScreen = require('./utils/is-smallscreen.js');
const sondageDialog = require('./modules/sondage-dialog.js').init;
const etiquettes = require('./modules/etiquettes.js').init;
const facets = require('./modules/facets.js');
const scrollTop = require('./modules/scroll-top.js').init;
const buttonSwitch = require('./modules/switch-button.js').init;
const faq = require('./modules/faq.js').init;
const externalLinks = require('./modules/rel-external.js').init;
const toggleTips = require('./modules/toggletip.js').init;
//const notifier = require('./modules/notifier.js').init;
const searchHistory = require('./modules/searchhistory.js');
const searchBanner = require('./modules/search-banner.js');
const menuBdl = require('./modules/menu-bdl.js');
const sondage = require('./modules/sondage.js').init;
const introjs = require('./modules/introjs.js');
const pagination = require('./modules/pagination.js').init;
const consentementCookies = require('./modules/consentementCookies.js');

document.querySelector('html').classList.remove('no-js');
document.querySelector('html').classList.add('js');

// CSS features detection
if (!window.getComputedStyle(document.querySelector('img')).objectFit) {
  document.querySelector('html').classList.add('no-objectFit');
}

// Breadcrumb navigation
navBreadcrumb();

menuBdl.init();

// // Set a global property to get the html[lang] value
// Object.defineProperty(window, 'LANG', { value: document.querySelector('html').getAttribute('lang') });

buttonSwitch();

// Forms //
forms.init();

// FormatHumanDate.init();

// Contenttable tables
contenttables.init();

// // Accordions
accordions.init();

// Etiquettes
etiquettes();

// // TOC navigation
// navToc.init();

// Share content to social media
share.init();

// Facets
facets.init();

// Pagination
pagination();


// Show/Hide the ScrollTop button
scrollTop();

// FAQ
faq();

// External Links [rel="external"]
externalLinks();

// Toggle Tips
toggleTips();

searchHistory.init();
//to get the history, call getHistorySorted
//console.log(searchHistory.getHistorySorted());
searchBanner.init();


// Scroll à l'endroit de la facette cochée. Si on a pas de position enregistrée et qu'on est en haut de la page, focus dans le champ de recherche
var posY = sessionStorage.getItem("posY");
if ( posY ) {
  window.scrollTo({top: posY, behavior: "instant"});
  sessionStorage.removeItem("posY");
} else if ( window.scrollY == 0 ) {
  document.getElementById('searchBannerField').focus();
}

// Loi 25
consentementCookies.init();

// Sondage
sondage();

// introjs
introjs.init();

// Status notification for cookies consent
// One notifier at the time
/*notifier(
  `<p>En poursuivant votre navigation sur ce site, vous acceptez les
témoins et autres technologies de suivi sur le Web qui sont utilisés, entre autres, pour améliorer votre
expérience de navigation et pour personnaliser le contenu du site
Internet. Pour plus d’information, consultez notre <a
href="https://www.oqlf.gouv.qc.ca/politique.html" rel="external"
target="_blank">Politique de confidentialité</a><svg
aria-hidden="true" class="ico-relexternal" height="11px" role="img"
width="11px"><use xlink:href="#ico_lienexterne"></use></svg>.</p>
<button type="button" data-cc="c-settings">Paramétrer</button>
<button type="button" data-cc="accept-all">Tout accepter</button>
`, {closable: true, type: 'consent'}
);*/

// Sondage dialog modal
sondageDialog();

const getUrlParameter = require("./utils/url.js");

let queryParameters = getUrlParameter("tx_powermail_pi1[reference]");

if (queryParameters && document.getElementById("powermail_field_reference_23")) {
  document.getElementById("powermail_field_reference_23").value = queryParameters;
}
